module.exports = __webpack_public_path__ + "img/chevron-right.56bf7098.svg";